import React, { useEffect, useState } from "react";
import Footer from "../components/Footer/Footer";
import Gallery from "../components/Gallery/Gallery";
import Header from "../components/Header/Header";
import Loader from "../components/Loader/Loader";
import ServiceCard from "../components/ServiceCard/ServiceCard";
import HeroBg from "../components/HeroBg/HeroBg";
import { useNavigate } from "react-router-dom";
import Meta from "../components/Meta";

function OurServices({
  hero_title,
  about_img_one,
  about_img_one_desc,
  about_img_two,
  about_img_two_desc,
  why_desc,
  s_one,
  s_two,
  s_three,
  s_four,
  f_one_title,
  f_one_desc,
  f_two_title,
  f_two_desc,
  f_three_title,
  f_three_desc,
  f_four_title,
  f_four_desc,
  c_one_title,
  c_one_desc,
  c_two_title,
  c_two_desc,
  images,
}) {
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const timer = setTimeout(() => {
      setLoading(false);
    }, 500);

    return () => clearTimeout(timer);
  }, []);

  const renderSection = ({ imgSrc, description, reverse = false }) => (
    <section className="cctv-about about_section layout_padding-bottom">
      <div className="container">
        <div className="row align-items-center">
          {reverse ? (
            <>
              <div className="col-md-6">
                <div className="detail-box">
                  <p className="about-description">{description}</p>
                </div>
              </div>
              <div className="col-md-6">
                <div className="img-box">
                  <img
                    src={imgSrc}
                    alt="About Vitri Enterprises"
                    className="about-image"
                  />
                </div>
              </div>
            </>
          ) : (
            <>
              <div className="col-md-6">
                <div className="img-box">
                  <img
                    src={imgSrc}
                    alt="About Vitri Enterprises"
                    className="about-image"
                  />
                </div>
              </div>
              <div className="col-md-6">
                <div className="detail-box">
                  <p className="about-description">{description}</p>
                </div>
              </div>
            </>
          )}
        </div>
      </div>
    </section>
  );

  return (
    <div>
      <Meta
        title="VITRI ENTERPRISES"
        description="Explore the security and communication services offered by VITRI ENTERPRISES, including CCTV installation, EPABX, video door phones, boom barriers, access control systems, and structured networking."
        keywords="CCTV services, EPABX installation, video door phone, access control, boom barrier solutions, networking services Gujarat"
        canonical="https://vitrienterprises.in/services"
      />

      {loading ? (
        <Loader />
      ) : (
        <>
          <Header />
          <HeroBg title={hero_title} />
          {renderSection({
            imgSrc: about_img_one,
            description: about_img_one_desc,
            reverse: false,
          })}
          {renderSection({
            imgSrc: about_img_two,
            description: about_img_two_desc,
            reverse: true,
          })}

          <div className="vitri-container">
            <section className="intro">
              <h1>Why Choose Vitri Enterprises?</h1>
              <p className="tagline">Expertise That Counts</p>
              <p>{why_desc}</p>
            </section>
            <ServiceCard
              s_one={s_one}
              s_two={s_two}
              s_three={s_three}
              s_four={s_four}
            />
            <section className="features">
              <div className="feature-card">
                <h2>{f_one_title}</h2>
                <p>{f_one_desc}</p>
              </div>
              <div className="feature-card">
                <h2>{f_two_title}</h2>
                <p>{f_two_desc}</p>
              </div>
              <div className="feature-card">
                <h2>{f_three_title}</h2>
                <p>{f_three_desc}</p>
              </div>
              <div className="feature-card">
                <h2>{f_four_title}</h2>
                <p>{f_four_desc}</p>
              </div>
            </section>
            {images ? <Gallery images={images} /> : <></>}
            <section className="cta">
              <h2>{c_one_title}</h2>
              <p>{c_one_desc}</p>
            </section>
            <hr />
            <section className="cta">
              <h2>{c_two_title}</h2>
              <p>{c_two_desc}</p>
            </section>
            <hr />
            <div className="gt-btn-div">
              <button
                className="learn-more"
                aria-label="Get in touch"
                onClick={() => navigate("/contact")}
              >
                <span className="circle" aria-hidden="true">
                  <span className="icon arrow"></span>
                </span>
                <span className="button-text">Contact Us</span>
              </button>
            </div>
          </div>
          <Footer />
        </>
      )}
    </div>
  );
}

export default OurServices;
